// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2Y3DS","list":"BalanceDue_list__hdXOu","listRow":"BalanceDue_listRow__3nuwN","total":"BalanceDue_total__1YCQD"};